import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styled from '@emotion/styled';

import Panel from './Panel';
import { spacing, leading, getTextType } from '../../style';
import breakpoints from '../../theme/material/breakpoints';

const InfoContainer = styled('div')({
  ...spacing.MARGIN_BOTTOM_LG,
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridGap: '0 15px',
  [breakpoints.down(768.05)]: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  ['@media (min-width: 768px) and (max-width: 820px) ']: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  [breakpoints.between(1024, 1084)]: {
    gridGap: '0 5px',
  },
});

const Info = styled('span')(() => ({
  display: 'inline-block',
  ...getTextType().toggleButton,
  ...leading.LOOSE,
  ...spacing.PADDING_RIGHT_SM,
  breakWord: 'nowrap',
  border: 'transparent',
  background: '#2B8FD7',
  color: '#FFFFFF',
  margin: 6,
  padding: '8px 18px',
  borderRadius: 4,
  marginLeft: 0,
  textAlign: 'center',
  height: 13,
  lineHeight: '13px',
  [breakpoints.down(350.05)]: {
    fontSize: 12,
  },
  [breakpoints.between(1024, 1084)]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface PanelTagsWithHeaderProps {
  title: any;
  data: any;
  className: any;
  toggleEditable: any;
  panelStyle?: string;
  editable?: boolean;
  [rest: string]: any;
}

const PanelTagsWithHeader = ({
  title,
  data,
  className,
  toggleEditable,
  ...rest
}: PanelTagsWithHeaderProps): ReactElement => {
  const renderItems = () => {
    if (isEmpty(data)) return null;

    return Object.keys(data).map(key => {
      const item = data[key];

      return <Info key={key}>{item}</Info>;
    });
  };

  return (
    <Panel withHeader title={title} className={className} toggleEditable={toggleEditable} {...rest}>
      <InfoContainer>
        {
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          renderItems(data)
        }
      </InfoContainer>
    </Panel>
  );
};

PanelTagsWithHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.array,
};

PanelTagsWithHeader.defaultProps = {
  className: '',
  title: '',
  data: [],
};

export default PanelTagsWithHeader;
